import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { EditIconButton } from "../../../main/components/EditIconButton";
import { useEffect, useState } from "react";
import { EditTextInfoModal } from "../../../main/components/EditTextInfoModal";
import { alarmsApi } from "../../../services/api";
import { AlarmDetails } from "../types";
import { AlarmSelectModal } from "./AlarmSelectModal";
import { IoIosArrowBack } from "react-icons/io";

const nameSchema = yup.object().shape({
  name: yup.string(),
});

export function AlarmConsultHeader(props: {
  alarm: AlarmDetails | null;
  setAlarm: (alarm: AlarmDetails) => void;
  onMount: () => void;
  alarmSeverity: number | JSX.Element;
  text: string;
}) {
  const { alarmSeverity, text, alarm, setAlarm, onMount } = props;
  const [showNameEditForm, setShowNameEditForm] = useState<boolean>(false);
  const [showSeverityEditForm, setShowSeverityEditForm] =
    useState<boolean>(false);
  const [newAlarmName, setNewAlarmName] = useState<string>("");
  const [severity] = useState<AlarmDetails>();
  const [, setNewAlarmSeverity] = useState<number | JSX.Element>();
  const navigate = useNavigate();

  const confirmAlarmNameChange = async () => {
    // Remove espaços em branco extras do início e do final do novo nome
    const trimmedName = newAlarmName.trim();
    // Verifica se o nome após a remoção dos espaços em branco é vazio
    if (trimmedName === "") {
      return;
    }
    if (alarm && alarm.code) {
      try {
        await alarmsApi.patchNameAlarm(alarm.code, trimmedName);
        const updateDetails = await alarmsApi.getAlarmDetails(alarm.code);
        setAlarm(updateDetails);
      } catch (error) {
        console.error("Erro ao enviar solicitação:", error);
      }
    }
  };

  const update = () => {
    setNewAlarmName(alarm?.name ?? "");
    setNewAlarmSeverity(alarmSeverity ?? "");
  };
  useEffect(() => {
    update();
  }, [alarm, severity]);

  const location = useLocation();

  const handleGoBack = () => {
    console.log(location.state?.navigateFrom)
    if (location.state?.navigateFrom == "center-operations") {
      navigate(-1);
      return;
    }

    navigate("/alarm/matriz")
  }

  return (
    <>
      <Grid container spacing={2} item>
        <Grid
          item
          xl={0}
          lg={1}
          md={1}
          sm={1}
          xs={1} //extra small/mobile
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={handleGoBack}
              sx={{
                width: {
                  xs: "35px",
                  sm: "40px",
                },
                height: {
                  xs: "35px",
                  sm: "40px",
                },
              }}
            >
              <IoIosArrowBack />
            </IconButton>
          </Box>
        </Grid>
        <Grid item lg={2} md={3} sm={5} xl={1} xs={6}>
          <Typography
            fontSize={{
              xs: "13px",
              sm: "16px",
            }}
          >
            {alarm?.name}
            <EditIconButton
              onClick={() => {
                setShowNameEditForm(true);
              }}
              tooltipText={"Editar nome do alarme"}
            />
          </Typography>{" "}
          <Typography
            sx={{
              fontSize: "11px",
            }}
          >
            {alarm?.code}
          </Typography>
        </Grid>
        <EditTextInfoModal
          confirmationModalContentText="Deseja confirmar a alteração do Nome do Alarme?"
          confirmationModalTitle="Alterar Nome"
          schema={nameSchema}
          fieldName={"name"}
          label={"Nome do Alarme"}
          open={showNameEditForm}
          setOpen={setShowNameEditForm}
          title={"Alterar Nome do Alarme"}
          errorModalTitle="Erro ao alterar Nome do Alarme"
          errorModalContentText="Ocorreu um erro ao alterar o nome do alarme, tente novamente mais tarde."
          successModalTitle="Nome do Alarme alterado com sucesso"
          successModalContentText="O nome do alarme foi alterado com sucesso!"
          newInfo={newAlarmName}
          setNewInfo={setNewAlarmName}
          onConfirm={confirmAlarmNameChange}
          onMount={onMount}
        />
        <Grid
          item
          xl={10}
          sm={4}
          md={8}
          lg={9}
          xs={5}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "flex-end",
            flexWrap: "wrap",
          }}
        >
          <Typography
            fontSize={{
              xs: "13px",
              sm: "16px",
            }}
          >
            {text}
            <EditIconButton
              onClick={() => {
                setShowSeverityEditForm(true);
              }}
              type="submit"
              tooltipText={"Editar Severidade do Alarme"}
            />
          </Typography>{" "}
          <Typography
            sx={{
              fontSize: "11px",
            }}
          >
            {alarmSeverity}
          </Typography>
        </Grid>
        <AlarmSelectModal
          alarm={alarm}
          showAddFormModal={showSeverityEditForm}
          setShowAddFormModal={setShowSeverityEditForm}
          onMount={onMount}
        />
      </Grid>
    </>
  );
}
